/** Spec 036: per-symbol base price/volatility/decimals table (port of the prototype's `BASE`). */

export interface SymbolBase {
  /** Base price. */
  p: number
  /** Per-bar volatility. */
  v: number
  /** Price decimals. */
  dp: number
}

const BASE: Record<string, SymbolBase> = {
  XAUUSD: { p: 2650, v: 0.00085, dp: 2 },
  'EUR/USD.SIM': { p: 1.085, v: 0.00032, dp: 5 },
  EURUSD: { p: 1.0852, v: 0.00032, dp: 5 },
  GBPUSD: { p: 1.2718, v: 0.00038, dp: 5 },
  BTCUSD: { p: 64200, v: 0.0016, dp: 1 },
  XAGUSD: { p: 31.4, v: 0.0012, dp: 3 },
  USDJPY: { p: 149.2, v: 0.00035, dp: 3 },
  AUDUSD: { p: 0.6612, v: 0.0004, dp: 5 },
  XAUUSDT: { p: 2651, v: 0.00085, dp: 2 },
  BTCUSDT: { p: 64210, v: 0.0016, dp: 1 },
  'BTCUSDT-PERP.BINANCE': { p: 64210, v: 0.0016, dp: 1 },
  ETHUSDT: { p: 2615, v: 0.002, dp: 2 },
  SOLUSDT: { p: 152.4, v: 0.0028, dp: 3 },
  NASDAQ: { p: 18400, v: 0.0011, dp: 2 },
  NQ: { p: 25000, v: 0.0011, dp: 2 },
  GC: { p: 4000, v: 0.0009, dp: 1 },
  NQ1: { p: 20100, v: 0.0011, dp: 2 },
}

const FALLBACK: SymbolBase = { p: 100, v: 0.001, dp: 2 }

export function baseFor(symbol: string): SymbolBase {
  return BASE[symbol] ?? FALLBACK
}
